<template>
  <div class="mt-3">
    <b-row>
      <b-col md="12" sm="12">
        <p class="mb-4 px-4">
          <small>
            Les messages enregistrés peuvent être sélectionnés lorsque vous
            offres une rétroaction à l'intervention d'un participant.
          </small>
        </p>
        <hr />
      </b-col>
    </b-row>
    <p class="text-info">
      <strong>Vos messages enregistrés</strong>
    </p>
    <b-row class="my-4">
      <b-col cols="12" md="8">
        <b-table
          :items="predefinedMessages.data.data"
          :fields="fields"
          :busy="isBusy"
          bordered
        >
        </b-table>
        <b-pagination
          pills
          v-model="table.currentPage"
          :total-rows="table.totalRows"
          :per-page="table.perPage"
          class="my-0"
          @change="pageChange"
        ></b-pagination>
        <br />
        <b-btn v-b-modal.predefinedMsgModal pill variant="outline-info"
          >Ajouter un message enregistré</b-btn
        >
      </b-col>
    </b-row>
    <PrededinedMessageModal />
  </div>
</template>
<script>
/**
 * @file       Predefined message component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import store from "@/store";
import { mapState } from "vuex";
import PrededinedMessageModal from "@/modules/messages/components/predefinedMessageModal.vue";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  components: { PrededinedMessageModal },

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      fields: [
        {
          key: "message",
          label: "Message"
        }
      ]
    };
  },
  mounted() {
    store.commit("messages/setMessagesFilters", {
      reset: true,
      fields: {
        id: this.profile.id
      }
    });
    store.dispatch("messages/getMessages");
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      predefinedMessages: state => state.messages.messages,
      profile: state => state.auth.profile.data.data[0]
    }),

    /**
     * Pager table.
     *
     * @return     {Object}
     */
    table() {
      return {
        totalRows: this.predefinedMessages.data.total,
        currentPage: this.predefinedMessages.data.current_page,
        perPage: this.predefinedMessages.data.per_page
      };
    },

    /**
     * Check if the status of the predefined message is busy.
     *
     * @return     {bool}  Busy or not.
     */
    isBusy() {
      return this.predefinedMessages.status === "fetching";
    }
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Change predefined message page.
     *
     * @param      {int}  page     The page number
     */
    pageChange(page) {
      store.commit("messages/setMessagesFilters", {
        fields: { page }
      });
      store.dispatch("messages/getMessages");
    }
  }
};
</script>
